import * as React from 'react'
import { default as MuiList, ListProps } from '@mui/material/List'

const List = (props: ListProps) => {
  return <MuiList {...props} />
}

export default List
